import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDF5o1-ubeAy-mbHMm6NFFqw8Xwk_ZmfH8",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "kevin-ai-website.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "kevin-ai-website",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "kevin-ai-website.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "938134903025",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:938134903025:web:6b8c26ac75b448455ab150"
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const googleProvider = new GoogleAuthProvider()
export const db = getFirestore(app)

export default app
